/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { DEFAULT_INDIVIDU } from '@/constants';
import type { Individu } from '@/types';

export type AssistantContextType = Individu & {
  onChange: any;
  onReset;
  errors: Record<string, any>;
  setErrors: (errors: Record<string, any>) => void;
  teledossierData?: any;
  setTeledossierData: (data: any) => void;
  isLoadingHubeeData?: boolean;
  setIsLoadingHubeeData: (isLoading: boolean) => void;
};

const AssistantContext = React.createContext<AssistantContextType>({
  onChange: () => {},
  onReset: () => {},
  errors: {},
  setErrors: () => {},
  teledossierData: null,
  setTeledossierData: () => {},
  isLoadingHubeeData: false,
  setIsLoadingHubeeData: () => {},
  ...DEFAULT_INDIVIDU,
});

export default AssistantContext;
